'use client';

import { Flex, freddyTheme, Link, Tag, Typography } from '@coolblue-development/freddy';
import { Image } from '@coolblue-development/next-image/client';
import { StoresStockOverlay } from '@coolblue-development/next-stores/client';
import type { Product } from '@features/product/typings';
import { useTranslation } from '@i18n/useTranslation';
import { useState } from 'react';

type StoresStockOverlayProduct = Parameters<typeof StoresStockOverlay>[0]['product'];

type ShowroomAvailabilityBlockProps = {
  variant: 'small' | 'large';
  product: Product;
};

export const ShowroomAvailabilityBlock = ({ variant, product }: ShowroomAvailabilityBlockProps) => {
  const { t } = useTranslation('webshop.productPage.showroomAvailability.block');
  const [open, setOpen] = useState(false);

  const baseComponent = (
    <Flex gap={300}>
      <Tag
        variant='subtle'
        intent='neutral'
        onClick={() => setOpen(true)}
        component='button'
        type='button'
      >
        {t('tagTitle')}
      </Tag>
      <Link onClick={() => setOpen(true)} component='button' type='button'>
        {t('link')}
      </Link>
      <StoresStockOverlay
        open={open}
        onClose={() => setOpen(false)}
        product={product as unknown as StoresStockOverlayProduct}
        personalPrice={product.personalPrice}
      />
    </Flex>
  );

  return variant === 'small' ? (
    baseComponent
  ) : (
    <Flex gap={500}>
      <Image
        imageId='558953'
        objectFit='cover'
        fileCollection='content'
        width={150}
        height={150}
        background='transparent'
        alt=''
        loading='lazy'
        sx={{ borderRadius: freddyTheme.borderRadius[100], width: '10rem', height: '10rem' }}
      />
      <Flex direction='column' gap={100} justifyContent='center'>
        {baseComponent}
        <Typography>{t('description')}</Typography>
      </Flex>
    </Flex>
  );
};
